




















































import { Vue, Component } from "vue-property-decorator";
import { getParam } from "@/api/teacherInfoManage";
import importAndExportMixin from "@/mixins/importAndExport";

@Component({
  name: "expertInfoImport",
  components: {
    UploadProgress: () => import("@/components/UploadProgress/index.vue")
  },
  mixins: [importAndExportMixin]
})
export default class extends Vue {
  private projectId = "";
  private projects: any[] = [];
  private status = "1";

  get uploadUrl() {
    return window.config.baseUrl4Shool + "/baseinfo/teacherinfo/upload";
  }

  get uploadData() {
    return { status: this.status, projectId: this.projectId, progressId: -1 };
  }

  created() {
    this.loadProjects();
  }

  private async loadProjects() {
    const res = await getParam();
    this.projects = res.data.projects || [];
  }

  private submitUpload() {
    (this.$refs.upload as any).submit();
  }

  private uploadSuccess(res: any) {
    (this as any).handleUploadSuccess(res, "教师信息上传失败.xlsx");
  }

  private handleUploadError(err: any) {
    this.$message.error(err && err.mesg ? err.mesg : "上传失败");
  }

  private goBack() {
    this.$router.push({ path: "/baseInfo/teacherInfoManage" });
  }
}
